import { render, staticRenderFns } from "./PassengerPhonenumberEditor.vue?vue&type=template&id=45b1f33c"
import script from "./PassengerPhonenumberEditor.vue?vue&type=script&lang=ts"
export * from "./PassengerPhonenumberEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports